import React from 'react';
import { useIsMounted } from '../../hooks/useIsMounted';

import './Select.scss';

interface IOption {
  name: string;
  value: string;
}

export interface ISelectProps {
  id?: string;
  value: string | number;
  options: IOption[];
  onSelect: (value: string) => void;
  ariaLabel?: string;
  className?: string;
}

const Select = ({
  id,
  value,
  options,
  onSelect,
  ariaLabel,
  className = '',
}: ISelectProps) => {
  const selected = options.find((option) => option.value === value);
  const { isMounted } = useIsMounted();
  const selectionId = isMounted ? selected?.value || 'selected' : 'selected';
  const selectionName = isMounted ? selected?.name : '';

  return (
    <div className={`select ${className}`}>
      <span
        className="select__selected"
        style={{ pointerEvents: 'none' }}
        aria-hidden={true}
        id={selectionId}
      >
        {selectionName}
      </span>
      <span className="select__arrows" />

      <select
        className={`select__input `}
        name="Select"
        id={id || 'select'}
        onChange={(e) => onSelect(e.target.value)}
        value={value}
        aria-label={ariaLabel}
      >
        {options.map(({ name, value }) => (
          <option key={name} value={value} id={value}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
